import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import ReviseProjectProposalCompareVersion from 'features/ReviseProjectProposal/pages/CompareVersion';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function CompareVersionPage() {
  const { t } = useTranslation();

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <>
          <Can do="read_detail" on="council">
            <ReviseProjectProposalCompareVersion />
          </Can>
          <Can not do="read_detail" on="council">
            <h4 className="text-red-500">{t('permission.forbid.detail.council')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default CompareVersionPage;
